<header class="row header">

    <div class="col-lg-3 col-sm-6 pull-left">
        <img class="img-fluid" src="./assets/media//logos/logo.svg">
    </div>

    <div class="col-lg-4 col-sm-6">
        <div class="row heaer-menu">
            <div class="col-lg-4 col-sm-6 pull-right">
                <kt-user-profile2></kt-user-profile2>
            </div>

            <div class="col-lg-4 col-sm-6 pull-right">
                <kt-language-selector-login></kt-language-selector-login>
            </div>
        </div>
    </div>



</header>